<template>
  <VModal :showing="showing" container-classes="max-w-screen-md" @update:showing="$emit('update:showing', $event)">
    <h2 class="mb-8 mr-8 text-xl truncate">Remove {{ drillDataSetName }} from this model?</h2>
    <p class="font-light text-gray-800">
      This will remove {{ drillDataSetName }} and all its associated layers from this model, potentially affecting multiple slides.
    </p>
    <div class="flex flex-row justify-end w-full mt-8 gap-4">
      <VButton class="w-42" data-testid="cancel-button" @click="$emit('update:showing', false)">Cancel</VButton>
      <VButton class="w-42" variant="danger" data-testid="remove-button" @click="$emit('remove-data-set')">Remove</VButton>
    </div>
  </VModal>
</template>

<script lang="ts" setup>
defineProps({
  drillDataSetName: {
    type: String,
    required: true,
  },
  showing: {
    type: Boolean,
    default: false,
  },
})

defineEmits(['remove-data-set', 'update:showing'])
</script>
